import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import { trackRemoveProductClick } from '../analytics';

const ItemContainer = styled.div`
  position: relative;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
  flex: 1;
  min-width: 280px;
  max-width: 320px;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  @media (max-width: 767px) {
    max-width: 100%;
  }
`;

const RemoveButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  color: #585858;
  transition: all 0.2s ease;
  padding: 0;

  &:hover {
    color: #333333;
  }
`;

const ProductImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
`;

const ProductInfo = styled.div`
  text-align: left;
  flex: 1;
  min-width: 0; /* Allow text to shrink */
`;

const ShingleLineLabel = styled.div`
  font-size: 14px;
  color: #333333;
  font-weight: 400;
  margin-bottom: 2px;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const ColorName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const ShingleComparisonItem = ({ shingle, shingleColor, onRemove, onClick }) => {
  const handleRemove = event => {
    event.stopPropagation();
    if (onRemove) {
      trackRemoveProductClick(shingle, shingleColor);
      onRemove(shingleColor.uuid);
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick(shingle, shingleColor);
    }
  };

  return (
    <ItemContainer onClick={handleClick}>
      <ProductImage
        src={shingleColor.swatch_160x160_url || shingleColor.image}
        alt={`${shingle.proper_name} ${shingleColor.name} swatch`}
      />

      <ProductInfo>
        <ShingleLineLabel>{shingle.proper_name}</ShingleLineLabel>
        <ColorName>{shingleColor.name}</ColorName>
      </ProductInfo>

      <RemoveButton onClick={handleRemove} aria-label={`Remove ${shingleColor.name} from comparison`}>
        ×
      </RemoveButton>
    </ItemContainer>
  );
};

ShingleComparisonItem.propTypes = {
  shingle: PropTypes.shape({
    proper_name: PropTypes.string,
  }).isRequired,
  shingleColor: PropTypes.shape({
    uuid: PropTypes.string,
    name: PropTypes.string,
    swatch_160x160_url: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  onRemove: PropTypes.func,
  onClick: PropTypes.func,
};

ShingleComparisonItem.defaultProps = {
  onRemove: null,
  onClick: null,
};

export default ShingleComparisonItem;
